function mapEtatFicheDem(etatFiche) {
  if (etatFiche === "" || etatFiche === null) {
    return "Non contacté";
  }

  switch (etatFiche) {
    case "0":
      return "Visites";
    case "1":
      return "Devis";
    case "2":
      return "Demande de rappel";
    case "3":
      return "Pas interessé / a déjà trouvé";
    default:
      return etatFiche;
  }
}

export default mapEtatFicheDem;
